import React from "react";

function OperationDashboard() {
    return (
        <div className="min-h-[80vh] flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-5xl font-extrabold text-gray-800 drop-shadow-sm tracking-wide">
                Coming <span className="text-primary">Soon</span>!
            </h1>

            <p className="mt-4 text-gray-500 text-lg max-w-md">
                We're working hard to bring you something amazing. Stay tuned!
            </p>

            <div className="mt-8 animate-spin rounded-full h-12 w-12 border-t-4 border-primary border-solid"></div>
        </div>
    );
}

export default OperationDashboard;
